import { inject, Injectable } from '@angular/core';
import { SelectOption } from '@grupo-constant/next-dtype/types';
import { HttpService } from '../http/http.service';
import { NextMethodsEnum } from './next-methods.enum';

@Injectable({
    providedIn: 'root'
})
export class EnumsService {

    private httpService = inject(HttpService);

    constructor() { }

    retrieveEnumerationType(enumerationClass: string) {
        return this.httpService.post<{ option: SelectOption[] }>(NextMethodsEnum.retrieveEnumerationType, { enumerationClass });
    }
}
